var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimalLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 126,
    viewBox: "0 0 200 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.45 97.3297C192.591 97.3297 200 89.92 200 80.7797C200 71.6394 192.591 64.2297 183.45 64.2297C174.31 64.2297 166.9 71.6394 166.9 80.7797C166.9 89.92 174.31 97.3297 183.45 97.3297Z",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.31 95.0297C192.45 95.0297 199.86 87.62 199.86 78.4797C199.86 69.3394 192.45 61.9297 183.31 61.9297C174.169 61.9297 166.76 69.3394 166.76 78.4797C166.76 87.62 174.169 95.0297 183.31 95.0297Z",
    fill: "#96F2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.73 84.5197C185.53 85.5097 191.02 81.6197 192.01 75.8197",
    stroke: "#12B886",
    strokeWidth: 1.1897,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.421 77.4997C175.989 77.4997 176.451 77.0385 176.451 76.4697C176.451 75.9008 175.989 75.4397 175.421 75.4397C174.852 75.4397 174.391 75.9008 174.391 76.4697C174.391 77.0385 174.852 77.4997 175.421 77.4997Z",
    fill: "#0CA678",
    stroke: "#0CA678",
    strokeWidth: 0.5949,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.8 69.5596C186.368 69.5596 186.83 69.0985 186.83 68.5296C186.83 67.9608 186.368 67.4996 185.8 67.4996C185.231 67.4996 184.77 67.9608 184.77 68.5296C184.77 69.0985 185.231 69.5596 185.8 69.5596Z",
    fill: "#0CA678",
    stroke: "#0CA678",
    strokeWidth: 0.5949,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9351 51.238L10.6953 55.418L14.8753 62.6577L22.1151 58.4777L17.9351 51.238Z",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.58 46.4906C164.58 46.4906 179.73 55.3306 192.66 39.2106",
    stroke: "#12B886",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.641 41.8005L192.431 39.4105L190.041 39.6205L190.971 38.5205L193.361 38.3105L193.561 40.6905L192.641 41.8005Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.305 103.345L126.676 100.748L124.078 107.377L130.708 109.975L133.305 103.345Z",
    stroke: "#12B886",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7598 107.39L37.7898 103.82",
    stroke: "#12B886",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 122.849L34.23 110.949",
    stroke: "#12B886",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.570312 15.7793L20.7903 26.4793",
    stroke: "#12B886",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 10.0703L22.7913 19.5903",
    stroke: "#12B886",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.749 38.3C100.749 38.3 114.269 29.72 113.769 17.51C113.269 5.30005 91.2792 3.80005 91.2792 3.80005C91.2792 3.80005 84.9692 20.87 100.749 38.3Z",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6596 50.1801C57.6596 50.1801 52.8596 52.81 49.3096 51.42C45.7496 50.04 36.6696 43.4001 33.0796 56.4801C29.4896 69.5601 31.8196 68.9401 31.8196 68.9401L57.6596 50.1801Z",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.158 65.98C119.158 65.98 126.248 63.71 128.298 66.64C130.358 69.56 128.728 73.93 133.608 77.44C138.488 80.95 142.978 77.44 142.978 77.44C142.978 77.44 133.558 60.94 122.198 62.81C110.838 64.68 101.078 80.95 101.078 80.95C101.078 80.95 111.218 67.29 119.158 65.98Z",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.379 37.0401L116.829 30.6401C116.829 30.6401 135.219 29.3701 140.109 15.3001C140.109 15.3001 149.749 12.0001 154.699 23.7001C154.699 23.7001 151.579 5.05006 123.069 16.1601C94.5593 27.2701 110.379 37.0401 110.379 37.0401Z",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1586 22.37C70.1586 22.37 49.0086 12.61 30.0586 13.78C30.0586 13.78 62.0186 20.74 76.6686 41.89",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1178 76.31L73.6078 73.28C73.6078 73.28 56.3178 65.87 53.2578 56.67C53.2578 56.67 69.6178 56.06 75.9878 61.73C82.3578 67.4 79.3978 75.29 79.3978 75.29",
    fill: "#099268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1582 85.83C70.1582 85.83 71.6482 117.96 76.2382 122.55C80.8382 127.15 102.278 127.15 105.348 122.55C108.408 117.95 109.208 85.83 109.208 85.83H70.1582Z",
    fill: "#63E6BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9182 80.43C96.9182 80.43 104.598 73.44 109.178 83.49C113.008 91.92 109.178 96.09 109.178 96.09C109.178 96.09 88.4982 87.32 90.0282 84.26C91.5582 81.2 96.9182 80.43 96.9182 80.43Z",
    fill: "#0CA678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.348 88.85C105.348 88.85 100.748 79.66 96.918 80.42",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.899 94.98C155.899 94.98 147.449 78.13 138.649 75.83C129.849 73.53 106.529 64.77 102.699 79.32C102.699 79.32 121.649 65.92 133.099 81.49C135.979 85.41 139.769 88.61 144.149 90.72C147.129 92.15 150.979 93.64 155.899 94.98Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.918 9.04004C96.918 9.04004 106.878 13.79 100.748 36.77",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.119 15.22C153.509 9.60998 154.759 24.01 154.759 24.01C154.759 24.01 150.849 13.68 140.119 15.22Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8984 46.72C97.8984 46.72 99.2584 46.62 101.148 46.71C104.498 46.87 109.508 47.61 111.468 50.55C111.468 50.55 115.508 48.51 124.208 52.6C124.208 52.6 125.248 62.81 119.128 64.34C119.128 64.34 117.598 67.4001 117.598 68.9401C117.598 70.48 117.598 67.41 112.998 65.88C108.398 64.35 108.398 55.16 108.398 55.16C108.398 55.16 104.568 53.87 101.118 48.39",
    fill: "#099268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.069 65.8701C116.069 65.8701 114.709 53.61 111.469 50.55",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2379 41.36C76.2379 41.36 82.3679 30.64 79.2979 27.57C76.2279 24.5 71.6979 30.63 66.3079 32.17C60.9179 33.7 54.7879 39.83 54.7879 39.83C54.7879 39.83 50.1879 42.89 48.6579 47.49C47.1279 52.09 42.6879 41.36 45.6779 32.17C48.6679 22.98 61.0479 26.73 61.0479 26.73C61.0479 26.73 70.1079 27.58 76.2379 26.04",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1577 55.26C80.1577 55.26 74.9277 35.24 67.9277 32.17",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.418 34.54C62.418 34.54 70.888 33.53 75.098 41.28",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.158 53.05C80.158 53.05 89.638 42.59 89.068 28.95C88.498 15.31 73.178 0 73.178 0C73.178 0 68.458 18.35 70.048 26.02",
    fill: "#099268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0977 7.29004C75.0977 7.29004 81.9277 48.55 80.7377 55.73",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0891 81.19C93.0891 81.19 88.7291 60.64 77.1191 54.83",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6279 75.83C78.6279 75.83 74.2279 54.1 59.5879 52.48",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7177 80.38C69.7177 80.38 67.9777 78.04 61.3877 80.38L54.7877 79.86C54.7877 79.86 47.1277 81.19 45.5977 85.79C45.5977 85.79 48.7977 84.26 50.2677 85.79C51.7277 87.32 61.1277 92.32 67.1477 87.52",
    fill: "#099268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.759 87.41C117.339 93.96 120.949 95.07 120.949 95.07C120.949 95.07 124.259 93.71 123.829 88.7C122.219 69.56 102.689 79.32 102.689 79.32",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0879 35.3C89.0879 35.3 99.2179 64.34 96.1479 79.66C96.1479 79.66 100.408 36.62 89.0879 25.97",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8987 48.59C83.8987 48.59 83.5287 54.54 85.2487 61.74",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0879 45.49C89.0879 45.49 92.9379 64.49 93.0079 77.44",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.349 54.22C105.349 54.22 99.2195 68.93 97.6895 79.66C97.6895 79.66 100.599 53.87 100.259 47.59C99.9195 41.31 100.749 38.29 100.749 38.29",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.178 63.41C109.178 63.41 104.738 68.8 102.748 78.06",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.139 54.1L108.409 32.17",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.788 16.91C130.788 16.91 120.668 19.78 116.838 25.98C113.008 32.18 111.478 32.18 109.178 38.16",
    stroke: "#12B886",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.52 48.04C109.52 48.04 116.07 37.48 122.2 37.89C128.33 38.3 134.32 40.6 144.34 34.09C144.34 34.09 148.55 39.23 156.82 41.07C165.09 42.9 162.8 39.24 167.77 41.07C167.77 41.07 166.08 33.86 157.16 33.02C148.24 32.18 128.32 30.65 122.2 36.01C116.08 41.37 113.01 33.71 109.94 38.31C106.87 42.91 109.52 48.04 109.52 48.04Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1689 77.69C92.1689 77.69 85.8889 75.55 83.7189 77.43C83.7189 77.43 82.4589 73.29 77.1189 76.3C71.7789 79.31 68.1589 79.52 67.5289 85.11C66.8989 90.7 73.1689 101.1 73.1689 101.1C73.1689 101.1 83.0989 85.74 86.3889 85.78C89.6889 85.83 97.9089 87.46 92.1689 77.69Z",
    fill: "#12B886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.898 78.13C83.898 78.13 77.998 79.05 77.118 85.48C76.238 91.91 73.168 98.04 73.168 98.04",
    stroke: "#099268",
    strokeWidth: 1.627,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1179 54.83L52.0879 54.22C52.0879 54.22 59.5179 45.42 69.7179 46.91C79.9179 48.41 77.1179 54.83 77.1179 54.83Z",
    fill: "#099268"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimalLeftImage);
export default __webpack_public_path__ + "static/media/animalLeftImage.ee69766acc9346385fbf4cd8d930452c.svg";
export { ForwardRef as ReactComponent };